import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './global-components'
import './utils'
import './libs'
import moment from 'moment'
import upskill from './upskill'

import VueTailwind from 'vue-tailwind'
import TModal from 'vue-tailwind/dist/t-modal'
import VuejsDialog from 'vuejs-dialog'
// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import 'v-markdown-editor/dist/v-markdown-editor.css'

import Editor from 'v-markdown-editor'
import VRating from './components/Core/Rating'
Vue.component('v-rating',VRating)
// Tell Vue to install the plugin.
Vue.use(Editor)
Vue.use(VuejsDialog)
const components = {
  't-modal': {
    component: TModal,
    props: {
      fixedClasses: {
        overlay:
          'z-100  overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-opacity-50',
        wrapper: 'relative mx-auto z-50 px-3 py-12',
        modal: 'overflow-visible relative  rounded',
        body: 'p-3',
        header: 'border-b p-3 rounded-t',
        footer: ' p-3 rounded-b',
        close:
          'flex items-center justify-center rounded-full absolute right-0 top-0 -m-3 h-8 w-8 transition duration-100 ease-in-out focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
      },
      classes: {
        overlay: 'bg-black',
        wrapper: '',
        modal: 'bg-white shadow',
        body: 'p-3',
        header: 'border-gray-100',
        footer: 'bg-gray-100',
        close: 'bg-gray-100 text-gray-600 hover:bg-gray-200',
        closeIcon: 'fill-current h-4 w-4',
        overlayEnterClass: 'opacity-0',
        overlayEnterActiveClass: 'transition ease-out duration-100',
        overlayEnterToClass: 'opacity-100',
        overlayLeaveClass: 'opacity-100',
        overlayLeaveActiveClass: 'transition ease-in duration-75',
        overlayLeaveToClass: 'opacity-0',
        enterClass: '',
        enterActiveClass: '',
        enterToClass: '',
        leaveClass: '',
        leaveActiveClass: '',
        leaveToClass: '',
      },
      variants: {
        danger: {
          overlay: 'bg-red-100',
          header: 'border-red-50 text-red-700',
          close:
            'bg-red-50 text-red-700 hover:bg-red-200 border-red-100 border',
          modal: 'bg-white border border-red-100 shadow-lg',
          footer: 'bg-red-50',
        },
      },
    },
  },
}
Vue.use(VueTailwind, components)

Vue.prototype.$upskill = upskill
Vue.prototype.$moment = moment
router.beforeEach((to, from, next) => {
  let Token = window.localStorage.getItem('ctoken')
  if (to.path === '/login' || '/password_change') {
    next()
  } else if (!Token) {
    next(`/login`)
  } else {
    next()
  }
})

// Midone Theme
import './assets/sass/app.scss'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
